/**
 * editorHistory — 직렬화 스냅샷(SVG 문자열) 기반 undo/redo. 시제품 editor.html 의 history/cursor 를 옮긴 것.
 * 상한(80단계)을 넘으면 가장 오래된 스냅샷을 버린다. 원본은 `original` 에 따로 있어 「원본으로」(reset)는 언제나 되고,
 * dirty 는 현재 스냅샷 ≠ 원본이다.
 */
export const MAX_HISTORY = 80;

export class EditorHistory {
  constructor(original, max = MAX_HISTORY) {
    this.original = original;
    this.entries = [original];
    this.cursor = 0;
    this.max = max;
  }

  get current() {
    return this.entries[this.cursor];
  }

  get dirty() {
    return this.current !== this.original;
  }

  canUndo() {
    return this.cursor > 0;
  }

  canRedo() {
    return this.cursor < this.entries.length - 1;
  }

  /** 현재와 같으면 아무것도 안 하고 false. 다르면 redo 가지를 버리고 쌓는다. */
  push(snapshot) {
    if (snapshot === this.current) return false;
    this.entries = this.entries.slice(0, this.cursor + 1);
    this.entries.push(snapshot);
    if (this.entries.length > this.max + 1) this.entries.shift();
    this.cursor = this.entries.length - 1;
    return true;
  }

  undo() {
    if (!this.canUndo()) return null;
    this.cursor -= 1;
    return this.current;
  }

  redo() {
    if (!this.canRedo()) return null;
    this.cursor += 1;
    return this.current;
  }
}
